import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Card, CardBody, Spinner } from "reactstrap";
import OnlyHeader from "components/Headers/OnlyHeader";
import KnowledgeArticleForm from "./KnowledgeArticleForm";
import {
  getSingleKnowledgeArticle,
  updateKnowledgeArticle,
  clearSingleKnowledgeArticle,
} from "store/actions/chatbotKnowledgeAction";

const EditKnowledgeArticle = () => {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const { singleArticle, singleArticleLoader, saveArticleLoader } = useSelector(
    (state) => state.chatbotKnowledge
  );

  useEffect(() => {
    if (id) {
      dispatch(getSingleKnowledgeArticle(id));
    }
    return () => {
      dispatch(clearSingleKnowledgeArticle());
    };
  }, [dispatch, id]);

  const handleSubmit = (formData) => {
    dispatch(
      updateKnowledgeArticle(id, formData, () => {
        history.push("/admin/chatbot-knowledge");
      })
    );
  };

  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <Row>
          <Col>
            {singleArticleLoader ? (
              <Card className="shadow py-5 text-center">
                <CardBody>
                  <Spinner color="primary" size="lg" style={{ display: "block", margin: "0 auto" }} />
                  <p className="mt-3 text-muted mb-0">Loading article...</p>
                </CardBody>
              </Card>
            ) : singleArticle ? (
              <KnowledgeArticleForm
                onSubmit={handleSubmit}
                isLoading={saveArticleLoader}
                isEdit={true}
                initialValues={singleArticle}
              />
            ) : (
              <Card className="shadow py-5 text-center">
                <CardBody>
                  <h4>Article Not Found</h4>
                  <p className="text-muted">The requested article could not be loaded.</p>
                </CardBody>
              </Card>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EditKnowledgeArticle;
